import { decorate, observable, action, computed } from 'mobx';
import RenameSheetDialog from './components/RenameSheetDialog';
import { useStaticRendering } from 'mobx-react';
import ApiClient from "utils/ApiClient";

// useStaticRendering(typeof window === 'undefined');
// if (!window) {
//   window = {};
// }
class LeftHoverMenuStore {
  isPacksLoading = false;

  constructor(appStore) {
    this.appStore = appStore;
  }

  // OBSERVABLES
  packLists = []
  packs = []
  // currentListId = 0
  anchorEl = null //(Util.getCurrentListId() == "dashboard-tab" && !Util.isMainDashboard()) ? document.body : 
  isPacksMenu = false;
  currentTheme = "light_theme" //window.currentTheme
  listSelectedForMenu = null


  // ACTIONS  
  handleDrawerIconClick = (ev) => {
    this.showPacksMenu(Util.getActiveTab() == "list-page");
    this.setCurrentTheme(window.currentTheme)
    this.anchorEl = ev.currentTarget || ev;
  }

  getPackId() {
    if (PACK && PACK.id) {
      return PACK.id;
    } else {
      return null;
    }
  }

  handleMenuClose = () => {
    this.anchorEl = null;
  };

  showPacksMenu = (flag) => {
    this.isPacksMenu = typeof flag !== "undefined" ? flag : true;
  }

  // setCurrentListId = () => {
  //   this.currentListId = Util.getCurrentListId();
  // }

  get isCurrentThemeDark() {
    return this.currentTheme !== "light_theme";
  }

  setListSelectedForMenu(list) {
    this.listSelectedForMenu = list;
  }

  setCurrentTheme = (theme) => {
    this.currentTheme = theme
    Util.toggleTheme(theme);
  }

  selectSheetToPack = () => {
    viewPort.selectSheet();
    this.handleMenuClose();
  }

  handleListItemClick = (list, force) => {
    this.appStore.routerHistory.push(`/pack/${this.appStore.packStore.id}/list/${list.id}`)
    this.handleMenuClose();
    // let hash = list.isList !== false ? `#!/list-tab-${list.id}` : `#!/${list.id}`;

    // // window.location.hash = hash;
    // this.handleMenuClose();
    // if (list.isList !== false) {
    //   viewPort.onListTabChange(list, force)
    // } else {
    //   viewPort.onListTabChange()
    // }
    // this.setCurrentListId();
    // // this.appStore.setHelpScoutBeaconHeight();
    // if ($$("pack-tabs")) {
    //   $$("pack-tabs").setValue('list-tab-' + list.id);
    // }
    // this.appStore.gamificationStore.checkAndShow();
  }

  loadPackLists = async (packId) => {
    let me = this;
    me.packLists = [];

    if (!isLoggedInForFirstTimeSession) {
      // me.packLists.push({
      //   name: "Dashboard",
      //   id: 'dashboard-tab',
      //   isList: false,
      // });
    }
    // if (!PACK || !PACK.id) {
    //   // me.packLists.push({
    //   //   name: "Template Packs",
    //   //   id: 'pack-templates-tab',
    //   //   isList: false,
    //   // });
    //   return;
    // }
    try {
      this.isPackListsLoading = true;
      const response = await ApiClient.Packs.getPackLists({
        pack_id: packId || this.getPackId()
      })
      this.isPackListsLoading = false;

      me.packLists = me.packLists.concat(response.data);
      if (me.packLists.length > 0) {
        // me.handleListItemClick(me.packLists[0]);
      } else {
        // window.alert("No Lists in pack");
      }
      // if (me.packLists.length > 0 && Util.getCurrentListId() == "dashboard-tab") {
      // if (me.packLists.length > 0 && isLoggedInForFirstTimeSession) {
      //   me.handleListItemClick(me.packLists[0]);
      // } else if (!isLoggedInForFirstTimeSession && me.packLists.length > 1 && Util.getCurrentListId() == "dashboard-tab") {
      //   me.handleListItemClick(me.packLists[1]);
      // }
      // me.setCurrentListId();
    } catch (e) {
      console.log(e);
    }
    // me.appStore.gamificationStore.checkAndShow();
  };

  get currentPackId() {
    return this.appStore.packStore.id;
  }

  get currentListId() {
    return this.appStore.packStore.listId;
  }

  addPackList = (list) => {
    this.packLists.push(list);
    this.handleMenuClose();
  }

  loadPacks = async (showLoader = true) => {
    let me = this;

    try {
      if(showLoader) me.isPacksLoading = true;
      const response = await ApiClient.Packs.getPacks();
      if(showLoader) me.isPacksLoading = false;

      me.packs = [...response.data];
      if (LOGGED_IN_USER.canViewUsers) {
        me.packs.push({
          color: "",
          // created_at: "2018-01-18 22:06:36",
          // created_by: "2",
          // dashboard_id: "1",
          // description: "",
          help_tips: [],
          // icon: "",
          id: "system",
          is_admin: false,
          is_precreated: "0",
          leaf: true,
          lists: [],
          name: "System",
          template_id: "0",
          // updated_at: "2018-01-18 22:18:24"
        })
      }

      if(me.packs && Array.isArray(me.packs) && me.packs.length > 0) {
        let isWebsocketEnabled = me.packs[0]?.is_websocket_enabled ?? "1";
        this.appStore.is_websocket_enabled = isWebsocketEnabled === "1" ? true : false;
      }

      this.appStore.packStore.setPackToWindow();
    } catch (e) {
      console.log(e);
    }
  }

  removePack = (packId) => {
    this.packs = this.packs.filter(p => p.id !== packId);
  }

  goToHomePage = () => {
    this.appStore.routerHistory.push(`/`);
  }

  createPackInDashboard = async () => {
    if (this.isPackCreating) {
      return;
    }

    try {
      this.isPackCreating = true;
      const resp = await ApiClient.Packs.savePack({ name: "Untitled Package" });
      this.appStore.packStore.isNewlyCreatedSheet = true;
      this.isPackCreating = false;

      this.packs.unshift({ ...resp.data, is_new: true, is_admin: true });
      this.appStore.shouldFetchUserLists = true;
      this.handlePackItemClick(resp.data);
    } catch (e) {
      console.log(e);
      this.appStore.notificationStore.showNotification("Something went wrong. Please try again..", "error");
    }
  }

  importExistingTemplate = () => {
    if (this.createPackWindow) {
      this.createPackWindow.destroy();
    }
    //  let packInfo;
    this.importForm = Ext.create("TL.packs.CreatePack", {
      bodyStyle: "padding:10px",
      autoHeight: true,
      border: false,
      listData: {},
      pack: null,
      listeners: {
        success: Ext.bind(function (response) {
          let isDashboardEnabled = (this.packs && this.packs.length > 0) ? this.packs[0]?.is_dashboard_enabled : 0;
          this.packs.unshift({ ...response, is_dashboard_enabled: isDashboardEnabled, is_new: true, is_admin: true });
          this.appStore.shouldFetchUserLists = true;
          this.handlePackItemClick(response);
          // window.location.href = baseUrl + `/pack/${response.id}`;
          this.createPackWindow.close();
        }, this),
        close: Ext.bind(function () {
          this.createPackWindow.close();
        }, this),
        scope: this,
      },
    });
  
    this.createPackWindow = Ext.create("TL.Window", {
      width: 600,
      title: "Create Application",
      border: false,
      items: [
        {
          xtype: "panel",
          border: false,
          items: [this.importForm],
        },
      ],
    });
  
    this.createPackWindow.show();
  };

  clearLastCreatedPackId = () => {
    delete this.lastCreatedPackId;
  }

  createPack = (pack) => {
    this.handleMenuClose();
    if (this.createPackWindow) {
      this.createPackWindow.destroy();
    }

    pack = pack || null;

    this.importForm = Ext.create("TL.packs.CreatePack", {
      bodyStyle: "padding:10px",
      autoHeight: true,
      border: false,
      listData: {},
      pack: pack,
      listeners: {
        "success": Ext.bind(function (response) {
          if (pack) {
            // this.store.load();
          } else {
            this.appStore.routerHistory.push(`/pack/${response.id}`);
            // window.location.href = baseUrl + '/packs/index/id/' + response.id;
          }
          this.createPackWindow.close();
        }, this),
        "close": Ext.bind(function () {
          this.createPackWindow.close();
        }, this),
        scope: this
      }
    });

    this.createPackWindow = Ext.create('TL.Window', {
      width: 600,
      title: pack ? 'Edit Application' : 'Create Application',
      border: false,
      items: [{
        xtype: 'panel',
        border: false,
        items: [
          this.importForm
        ]
      }]
    });

    this.createPackWindow.show();
  };

  handlePackItemClick = (pack) => {
    this.appStore.routerHistory.push(`/pack/${pack.id}`);
    this.anchorEl = null;
    this.isPacksMenu = false;
    this.addToRecentPacks(pack.id)
    // window.location = baseUrl + '/packs/index/id/' + pack.id;
  }

  getRecentPackIds() {
    const recentPacksString = localStorage.getItem("recentPacks") ?? "[]";
    return new Set(JSON.parse(recentPacksString));
  }

  async addToRecentPacks(packId) {
    const recentPacks = this.getRecentPackIds();
    recentPacks.delete(packId);
    recentPacks.add(packId);

    localStorage.setItem("recentPacks", JSON.stringify([...recentPacks]));
  }

  removeSheetFromPack = (list) => {
    var me = this,
      msg = "Are you sure, do you want to remove this sheet from Application Pack? ";


    Ext.Msg.confirm('Delete confirmation', msg, function (btn) {
      if (btn === 'yes') {
        try {
          const resp = ApiClient.Packs.removeSheet({
            list_id: list.id,
            pack_id: PACK.id
          });
          me.removeListItem(list);
        } catch (e) {
          const response = e.response
          Ext.Msg.alert('', response?.message || "Something went wrong");
        }
      }
    }, this);
  }

  removeListItem(list) {
    let me = this;

    console.log(me.packLists);
    me.packLists = me.packLists.filter((packList) => packList.id != list.id);
    if (me.currentListId == list.id) {
      me.handleListItemClick(me.packLists[1] || me.packLists[0]);
    }
  }

  renderRenameDialog() {
    this.appStore.renderDialogWithoutStore(RenameSheetDialog, {
      list: viewPort.currentList,
      onChange: val => this.handleRenameSheet(val, viewPort.currentActiveTabList)
    });
  }

  async handleRenameSheet(newSheetName, list) {
    let me = this;

    try {
      const response = await ApiClient.List.saveListName({
        list_name: newSheetName,
        list_id: list.id
      });

      list = me.packLists.find((data) => data.id == list.id);
      list.name = newSheetName;

      if(this.appStore?.allUserLists && Array.isArray(this.appStore.allUserLists) && this.appStore.allUserLists.length > 0) {
        const userList = this.appStore.allUserLists.find((data) => data.id == list.id);
        if(userList){
          userList.name = newSheetName;
        }
      }
      // me.handleListItemClick(list, true);

      // const listTab = $$("pack-tabs").data.options.find(listTab => listTab.id == "list-tab-" + list.id);
      // if (listTab) {
      // listTab.value = "<span style='' data-qtip='Untitled'>" + newSheetName + "</span>";
      // $$("pack-tabs").refresh();
      // }
    } catch (e) {
      const response = e.response;
      console.log(e);
      Ext.Msg.alert('', response?.msg || "Something went wrong");
    }
  }

  deleteSheet = (list) => {
    var me = this,
      msg = "Are you sure, do you want to delete the tigersheet? ",
      uniqueIdForCheckBox = Util.getUniqueId();

    msg += "<br/><br/><input type='checkbox' id='should_send_email_" + uniqueIdForCheckBox + "' /> Send email notification to all the shared users";

    Ext.Msg.confirm('Delete confirmation', msg, function (btn) {
      if (btn === 'yes') {
        var shouldSendEmail = Ext.get('should_send_email_' + uniqueIdForCheckBox).getAttribute('checked')
        Ext.Ajax.request({
          url: baseUrl + '/items/delete-item',
          params: {
            item_id: list.id,
            should_send_email: shouldSendEmail ? 1 : 0
          },
          success: Ext.bind(function (response) {
            var resp = Ext.decode(response.responseText);
            if (resp.success) {
              this.removeListItem(list);
            } else {
              Ext.Msg.alert('', resp.messages ? resp.messages : resp.msg);
            }

          }, this)
        });
      }
    }, this);
  }

  setPacks(packs) {
    this.packs = packs
  }
}

decorate(LeftHoverMenuStore, {
  isPackListsLoading: observable,
  packLists: observable,
  anchorEl: observable,
  packs: observable,
  isPacksLoading: observable,
  isPacksMenu: observable,
  currentTheme: observable,
  listSelectedForMenu: observable,
  isPackCreating: observable,

  isCurrentThemeDark: computed,
  currentListId: computed,
  currentPackId: computed,

  setListSelectedForMenu: action,
  createPack: action,
  addPackList: action,
  setCurrentTheme: action,
  handleDrawerIconClick: action,
  handleMenuClose: action,
  // setCurrentListId: action,
  loadPackLists: action,
  loadPacks: action,
  //
  setPacks: action
});

export default LeftHoverMenuStore;